const nextTick = fn => {
	const channel = new MessageChannel();
	channel.port1.onmessage = () => fn();
	channel.port2.postMessage(null);
};
export default nextTick;
